var option_default = {
  "option": "uTi2C",
  "user_choice": "VxFaW",
  "check": "dw6W-",
  "image": "FrpKD",
  "input": "_5OxP6",
  "title": "seWC4",
  "centered": "_6M5Ka",
  "with_result": "XGpNl",
  "list": "h7DlN",
  "with_image": "LArpM",
  "progress": "e8wZU",
  "progress_value": "_6k3dR",
  "label": "D6Jgp",
  "cta": "TxQAd",
  "adornment_icon": "_88KGe",
  "remove": "LMV2J",
  "removeButton": "dclNR",
  "removeButtonIcon": "zYx09",
  "overlay": "LYIv8",
  "shown": "aQb5q",
  "dark": "z-jQD",
  "spinner": "_8DWkZ",
  "spin": "lXzmh"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
